import React from 'react';

export const ArrowLeftPrimaryIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.86182 2.86152C7.12205 2.60141 7.54386 2.60159 7.8042 2.86152C8.06455 3.12187 8.06455 3.54453 7.8042 3.80488L4.27686 7.3332H14.6665C15.0347 7.3332 15.3335 7.632 15.3335 8.00019C15.3333 8.36823 15.0346 8.66621 14.6665 8.66621H4.27588L7.8042 12.1955C8.06455 12.4559 8.06455 12.8775 7.8042 13.1379C7.54383 13.398 7.12209 13.3982 6.86182 13.1379L1.72412 8.00019L6.86182 2.86152Z"
        fill="#774EFF"
      />
    </svg>
  );
};
